__turbopack_context__.v({
  "wrapper": "MoneyPage-module__I8c1RW__wrapper",
});
